import {
  FETCH_LIST, COMPANY_INFO, ALL_COMPANIES_LIST, COMPANY_WALL_POSTS,
} from './types';

export default {
  [FETCH_LIST]: (state, payload) => {
    state.companies = payload.companies;
  },
  [COMPANY_INFO]: (state, payload) => {
    state.companyInfo = payload.companyInfo;
  },
  [COMPANY_WALL_POSTS]: (state, { companyWall, page }) => {
    if (page === 1) {
      state.companyWall = [...companyWall];
    } else {
      state.companyWall = [...state.companyWall, ...companyWall];
    }
  },
  [ALL_COMPANIES_LIST]: (state, payload) => {
    const { allCompaniesList, companiesCount, companiesNextPage } = payload;
    state.allCompaniesList = allCompaniesList;
    state.companiesCount = companiesCount || state.companiesCount;
    state.companiesNextPage = companiesNextPage || state.companiesNextPage;
  },
};
